// Behold Instagram feed renderer, loaded by both page-gallery.hbs and
// index.hbs (assets/built/gallery.js).
import { parseFeedItems, buildCardHtml } from './gallery-lib.js';

const SKELETON_COUNT = 6;

function renderSkeleton(container) {
    container.innerHTML = '<div class="feed-loading__cell"></div>'.repeat(SKELETON_COUNT);
}

function renderItems(container, items) {
    container.innerHTML = items.map(buildCardHtml).join('');
}

function renderEmpty(container) {
    container.innerHTML = '';
}

function initGallery() {
    const container = document.querySelector('#behold-feed-grid');
    if (!container) return;

    const feedUrl = container.dataset.beholdFeedUrl;
    if (!feedUrl) {
        console.error('[gallery] @custom.behold_feed_url is not set');
        renderEmpty(container);
        return;
    }

    renderSkeleton(container);

    fetch(feedUrl)
        .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
        })
        .then((data) => {
            const items = parseFeedItems(data);
            if (items.length === 0) {
                renderEmpty(container);
                return;
            }
            renderItems(container, items);
        })
        .catch((err) => {
            console.error('[gallery] fetch failed:', err);
            renderEmpty(container);
        });
}

initGallery();
